export const REPORT_ERROR = 'REPORT_ERROR';
export const REPORT_FLEX_EVENT = 'REPORT_FLEX_EVENT';
